import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  OriginalCurrencySign,
  OriginalPriceText,
  PriceRow,
  CurrencySign,
  PriceMain,
  PriceSub,
  PerYear,
  DiscountRow,
  OriginalPerYear,
  EmptyDiscount,
  PriceContainer,
} from './index.style';

const VND_SIGN = 'đ';
const USD_SIGN = '$';

const PackagePrice = ({ isVietnam, pricing, isRow, shouldShowDiscount }) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const { price, originalPrice } = pricing || {};

  const renderOriginalPrice = () => {
    const displayPrice = originalPrice?.toLocaleString(language);
    return (
      <>
        <OriginalCurrencySign isVietnam={isVietnam} isRow={isRow}>
          {isVietnam ? VND_SIGN : USD_SIGN}
        </OriginalCurrencySign>
        <OriginalPriceText isRow={isRow}>{displayPrice}</OriginalPriceText>
      </>
    );
  };

  const renderPrice = () => {
    let value = price?.toLocaleString(language);

    if (!isVietnam && value !== '0') {
      value = price?.toLocaleString(language, { minimumFractionDigits: 2 });
    }

    return (
      <PriceRow>
        <CurrencySign isVietnam={isVietnam} isRow={isRow}>
          {isVietnam ? VND_SIGN : USD_SIGN}
        </CurrencySign>
        <PriceMain>{isVietnam ? value?.slice(0, -4) || '0' : value}</PriceMain>
        {isVietnam && value?.slice(-4) !== '0' && (
          <PriceSub>{value?.slice(-4)}</PriceSub>
        )}
      </PriceRow>
    );
  };

  return (
    <PriceContainer isRow={isRow}>
      <PriceRow>
        {renderPrice()}
        {price !== 0 && <PerYear isRow={isRow}>{t('perYear')}</PerYear>}
      </PriceRow>
      {shouldShowDiscount ? (
        <DiscountRow>
          {renderOriginalPrice()}
          <OriginalPerYear isRow={isRow}>{t('perYear')}</OriginalPerYear>
        </DiscountRow>
      ) : (
        <EmptyDiscount />
      )}
    </PriceContainer>
  );
};

export default PackagePrice;
